import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, LinearProgress } from '@mui/material';

import { ForbiddenError, RoleEmployee, RoleUser } from '@homesusa/core';
import { AuthCompanyContext, useHasRole } from '@homesusa/auth';

export const EmployeePrivateRoute = ({
  allowedRoles
}: {
  allowedRoles: RoleEmployee[];
}): JSX.Element => {
  const { hasUserRole, hasEmployeeRole } = useHasRole();
  const { currentEmployee } = React.useContext(AuthCompanyContext);

  if (!hasUserRole([RoleUser.User])) {
    return <Outlet />;
  }

  if (!currentEmployee) {
    return (
      <Box sx={{ width: '100%' }}>
        <LinearProgress />
      </Box>
    );
  }

  if (hasEmployeeRole(allowedRoles)) {
    return <Outlet />;
  }

  return <ForbiddenError />;
};
